import { render, staticRenderFns } from "./SingularityFullWidthPanel.vue?vue&type=template&id=d6c3409e&"
import script from "./SingularityFullWidthPanel.vue?vue&type=script&lang=ts&"
export * from "./SingularityFullWidthPanel.vue?vue&type=script&lang=ts&"
import style0 from "./SingularityFullWidthPanel.vue?vue&type=style&index=0&id=d6c3409e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports